import { Modal } from "antd";
import { resolveAppMediaUrl } from "../utils/resolveAppMediaUrl";
import type { WeworkServiceCardView } from "./WeworkServiceType";
import "./WeworkServiceModal.css";

export type WeworkServiceModalProps = {
  open: boolean;
  title: string;
  content: string;
  card: WeworkServiceCardView | null;
  showDismiss?: boolean;
  onClose: () => void;
  onDismissForever?: () => void;
};

export function WeworkServiceModal(props: WeworkServiceModalProps) {
  const { open, title, content, card, showDismiss, onClose, onDismissForever } = props;
  const qrSrc = resolveAppMediaUrl(card?.qrcodeUrl?.trim() || null);

  return (
    <Modal
      open={open}
      title={title}
      footer={null}
      onCancel={onClose}
      destroyOnClose
      className="wework-modal wework-modal--space-agent"
      width={320}
      centered
    >
      <div className="wework-modal__body">
        {content ? <p className="wework-modal__content">{content}</p> : null}
        {qrSrc ? (
          <div className="wework-modal__qr-wrap">
            <p className="wework-modal__qr-hint">长按识别 或 截图保存后在微信中打开</p>
            <div className="wework-modal__qr-frame">
              <img src={qrSrc} alt="" className="wework-modal__qr" />
            </div>
            {card?.nickname?.trim() ? (
              <p className="wework-modal__nickname">{card.nickname.trim()}</p>
            ) : null}
          </div>
        ) : null}
        {showDismiss ? (
          <div className="wework-modal__foot">
            <button type="button" className="wework-modal__dismiss" onClick={onDismissForever}>
              下次不再提示
            </button>
          </div>
        ) : null}
      </div>
    </Modal>
  );
}
